import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import ClaimCommunicationImg from '../../../assets/img/claims/customers/communication/communicate.svg';
import ClaimCommunicationInfoImg from '../../../assets/img/claims/customers/communication/information.svg';
import CommunicationImg from '../../../assets/img/claims/customers/communication/summary.svg';
import ClaimCommunicationTrackingImg from '../../../assets/img/claims/customers/communication/tracking.svg';
import PageLayout from '../../../components/new-layout/PageLayout';
import { UnderLicenseClaim } from '../../../components/new-layout/UnderLicenseClaim';
import * as routing from '../../../constants/Routing';
import { intl } from '../../../helpers/IntGlobalProvider';
import { useRetrieveOrganization } from '../../../hooks/organization/useRetrieveOrganization';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import { useRetrieveUserCredentials } from '../../../hooks/user/useRetrieveUserCredentials';
import Text from '../../../react-components/Text';
import { NotificationsEmails } from './email';
import { NotificationsSMS } from './sms';

const styles = {
  divInside: {
    width: `100%`,
    height: `100%`,
    zIndex: 1,
    backgroundColor: RoutalPalette.neutral00,
    overflowY: `auto` as any,
  },
};

type NotificationsProps = {
  classes: {
    divInside: string;
  };
};

export const Notifications = withStyles(styles)(({ classes }: NotificationsProps) => {
  const navigate = useNavigate();
  const { data: userCredentials } = useRetrieveUserCredentials();
  const { data: organization } = useRetrieveOrganization();
  const { data: activeProject } = useRetrieveActiveProject();

  useEffect(() => {
    if (
      !userCredentials?.test(`can_manage_projects`) &&
      (!activeProject || !userCredentials?.projects.test(activeProject.id, `can_manage_customers_app`))
    ) {
      navigate(`${routing.PLANNER.ROOT.replace(`:projectId`, `${activeProject?.id}`)}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeProject]);

  if (!activeProject) {
    return null;
  }

  return (
    <PageLayout>
      <Grid container className={classes.divInside} direction="column" wrap="nowrap">
        {userCredentials?.subscription.test(`customers`) ? (
          <Routes>
            <Route
              index
              element={
                <Navigate
                  to={`${routing.CUSTOMERS.NOTIFICATIONS.EMAILS.replace(`:projectId`, `${activeProject?.id}`)}`}
                />
              }
            />

            <Route
              path="/emails"
              element={
                <NotificationsEmails project={activeProject} organizationSubscription={organization?.subscription} />
              }
            />

            <Route
              path="/sms"
              element={
                <NotificationsSMS project={activeProject} organizationSubscription={organization?.subscription} />
              }
            />

            <Route
              path="*"
              element={
                <Navigate
                  to={`${routing.CUSTOMERS.NOTIFICATIONS.EMAILS.replace(`:projectId`, `${activeProject?.id}`)}`}
                />
              }
            />
          </Routes>
        ) : (
          <UnderLicenseClaim
            headerText={intl.formatMessage({ id: `projects.communication.under_gorilla_claim.title` })}
          >
            <Grid container direction="column" alignItems="center">
              <VSpacer large />
              <VSpacer medium />

              <Grid
                item
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ maxWidth: `700px` }}
              >
                <img draggable="false" src={CommunicationImg} alt="" height="200" width="200" />
                <VSpacer large />
                <Text
                  variant="body-medium"
                  style={{ textAlign: `center`, fontSize: `13px` }}
                  intlId="projects.communication.under_gorilla_claim.header"
                />
              </Grid>

              <VSpacer large />

              <VSpacer large />

              <Grid
                item
                container
                direction="row"
                style={{ gap: `20px` }}
                alignItems="flex-start"
                justifyContent="center"
              >
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  style={{ maxWidth: `300px` }}
                >
                  <Grid item style={{ height: `120px` }}>
                    <img draggable="false" src={ClaimCommunicationImg} alt="" height="102" width="102" />
                  </Grid>
                  <VSpacer medium />
                  <Grid item>
                    <Text
                      style={{ textAlign: `center`, color: `#5073B5` }}
                      variant="h6"
                      intlId="projects.communication.under_gorilla_claim.content.1"
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  style={{ maxWidth: `300px` }}
                >
                  <Grid item style={{ height: `120px` }}>
                    <img draggable="false" src={ClaimCommunicationTrackingImg} alt="" height="102" width="102" />
                  </Grid>
                  <VSpacer medium />
                  <Grid item>
                    <Text
                      style={{ textAlign: `center`, color: `#5073B5` }}
                      variant="h6"
                      intlId="projects.communication.under_gorilla_claim.content.2"
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  style={{ maxWidth: `300px` }}
                >
                  <Grid item style={{ height: `120px` }}>
                    <img draggable="false" src={ClaimCommunicationInfoImg} alt="" height="102" width="102" />
                  </Grid>
                  <VSpacer medium />
                  <Grid item>
                    <Text
                      style={{ textAlign: `center`, color: `#5073B5` }}
                      variant="h6"
                      intlId="projects.communication.under_gorilla_claim.content.3"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </UnderLicenseClaim>
        )}
      </Grid>
    </PageLayout>
  );
});
